export default "/images/alert-triangle.svg?07c1eb3918fdd1ce90e1462397dc14f8";